import { FC, useMemo } from 'react';
import { getCurrencySymbol } from '@utils/getCurrencySymbol';
import { IDiscountBadgeProps } from './types';
import { discountColors } from './constants';

export const DiscountBadge: FC<IDiscountBadgeProps> = ({
  discountValue,
  discountType,
  price,
  currencyCode,
}) => {
  const discontColor = useMemo(() => {
    const discontRatio = discountType === 'percent' ? discountValue : price / discountValue;
    if (discontRatio < 10) return discountColors.green;
    else if (discontRatio < 30) return discountColors.yellow;
    else if (discontRatio < 50) return discountColors.orange;
    return discountColors.red;
  }, [discountType, price, discountValue]);

  return (
    <div className={`bg-gradient-to-b py-[4px] px-[8px] rounded-[6px] w-fit ${discontColor}`}>
      <p className="text-white small-text">
        -{discountValue}
        {discountType === 'percent' ? '%' : getCurrencySymbol(currencyCode)}
      </p>
    </div>
  );
};
